import { css } from '@emotion/react';
import { colors } from '#themes/stena-recycling';

export const styles = {
  Container: css`
    box-sizing: border-box;
    height: var(--input-container-height);
    text-align: center;
    padding: 1rem;
  `,
  InputGroup: css`
    position: relative;

    &:focus-within {
      outline: 2px solid var(--color-blue);
      outline-offset: -1px;
    }
  `,
  Input: css`
    box-sizing: border-box;
    margin: 0;
    width: 100%;
    height: 3rem;
    padding-left: 3rem;
    padding-right: 3rem;
    border: 1px solid ${colors.monochrome.grey40};
    border-radius: 0.25rem;
    font-family: inherit;
    font-size: 1rem;
    background-color: canvas;
    color: ${colors.base.black};

    &:hover,
    &:focus {
      border: 1px solid ${colors.primary.grey};
    }
  `,
  SearchIcon: css`
    box-sizing: border-box;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    height: 100%;
    left: 0.75rem;
    color: var(--color-gray-600);
  `,
  ClearButton: css`
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    padding: 0;
    border: none;
    border-radius: 999px;
    background: transparent;
    color: var(--color-gray-600);
    cursor: pointer;
    transform: translateY(-50%);

    &:hover {
      background-color: ${colors.background.grey};
      color: ${colors.base.black};
    }

    &:focus-visible {
      outline: 2px solid var(--color-blue);
      outline-offset: 1px;
    }
  `,
};
